import { render, staticRenderFns } from "./ScreenLaudoMama.vue?vue&type=template&id=c4d3129a&lang=true&"
import script from "./ScreenLaudoMama.vue?vue&type=script&lang=js&"
export * from "./ScreenLaudoMama.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports